import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Text from 'components/common/Text/Text'
import { dynamicDataAttribute } from 'helpers/utils'
import StepAppointment from './BOTMakeAppointmentHeader/components/StepAppointment'
import { DONE_STEP_ASSET } from 'constant'

const CollapsedTeaserContent = ({
  icon,
  description,
  title,
  stepInfo: {
    isDone,
    targetId
  }
}) =>
  <StepAppointment
    targetId={ targetId }
    padding={ 80 }
    asset={ icon }
    condition={ isDone }
    alternative={ DONE_STEP_ASSET }>
    <Text { ...dynamicDataAttribute(`step-${targetId}-title`) } block underline follow_link>{ title }</Text>
    <StepDescription
      { ...dynamicDataAttribute(`step-${targetId}-description`) }
      isDone={ isDone }
      follow_link
      small>
      { description }
    </StepDescription>
  </StepAppointment>

CollapsedTeaserContent.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.string,
  stepInfo: PropTypes.shape({
    isDone: PropTypes.bool,
    targetId: PropTypes.string
  }),
  title: PropTypes.string
}

CollapsedTeaserContent.type = 'AppointmentStepTeaserContent'

export default CollapsedTeaserContent

const StepDescription = styled(Text)`
  ${props => props.isDone && css`
    color: ${Theme.colors.green};
  `}
`
